import {
  AnalyticsContext
} from "./chunk-TRBEEQLV.mjs";

// src/hooks/use-analytics.ts
import { useContext } from "react";
function useAnalytics() {
  return useContext(AnalyticsContext);
}

export {
  useAnalytics
};
//# sourceMappingURL=chunk-TMCOW6ND.mjs.map